import { ButtonTypeColors, ButtonTypes, ButtonSizeEnums, ButtonsType } from '../enums/buttons.enums'

export const useButtonCustom = () => {
  return {
    ButtonTypeColors, ButtonTypes, ButtonSizeEnums, ButtonsType,
  }
}
